export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.dynamicPassword.required': 'Please input the dynamic password!',
  'pages.login.submit': 'Submit',
  'pages.login.loginSubmit': 'Login',
  'pages.login.backToAccount': 'Back to account login',
  'pages.login.bindTitle': 'Bind Dynamic Password',
  'pages.login.bindSuccess': 'Bound successfully',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.platform.bannerName': 'Banner Name',
  'pages.platform.bannerImage': 'Banner Image',
  'pages.platform.jumpLink': 'Jump Link',
  'pages.platform.linkJump': 'Link Jump',
  'pages.platform.internalJump': 'Internal Jump',
  'pages.platform.noJump': 'No Jump',
  'pages.platform.uploadTip': 'Only upload jpg/png/webp/gif files',
  'pages.platform.uploadError': 'Only upload jpg/png/jpeg/webp files',
  'pages.platform.chinese': 'Simplified Chinese',
  'pages.platform.uploadImage': 'Please upload image',
  'pages.platform.hallId': 'Hall ID:',
  'pages.platform.input': 'Input',
  'pages.platform.invitePage': 'Invite Page',
  'pages.platform.myAccount': 'My Account',
  'pages.platform.copy': 'Copy',
  'pages.platform.homePopup': 'Home Popup',
  'pages.platform.homeMarquee': 'Home Marquee',
  'pages.platform.language': 'Language',
};
